import { Component, ElementRef, HostBinding, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { style, animate, AnimationBuilder, AnimationPlayer } from '@angular/animations';
import { Subscription } from 'rxjs/Subscription';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';


import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as translationEnglish } from './i18n/en';
import { locale as translationRussian } from './i18n/ru';

import { navigation } from 'app/navigation/navigation';

@Component({
    selector   : 'fuse-theme-options',
    templateUrl: './theme-options.component.html',
    styleUrls  : ['./theme-options.component.scss'],
    animations : fuseAnimations
})
export class FuseThemeOptionsComponent implements OnInit, OnDestroy
{
    @ViewChild('openButton') openButton;
    @ViewChild('panel') panel;
    @ViewChild('overlay') overlay: ElementRef;

    public player: AnimationPlayer;
    config: any;

    onConfigChanged: Subscription;

    @HostBinding('class.bar-closed') barClosed: boolean;

    constructor(
        private animationBuilder: AnimationBuilder,
        private fuseConfig: FuseConfigService,
        private navigationService: FuseNavigationService,
        private renderer: Renderer2,
        private fuseTranslationLoader: FuseTranslationLoaderService
    )
    {
        this.fuseTranslationLoader.loadTranslations(translationEnglish, translationRussian);
        this.barClosed = true;

        this.onConfigChanged =
            this.fuseConfig.onConfigChanged
                .subscribe(
                    (newConfig) => {
                        this.config = newConfig;
                    }
                );

        const nav: any = navigation;
        const idx = nav.findIndex(item => item.id === 'custom-function');
        nav[idx].children.push(
            {
                'id'      : 'customize',
                'title'   : 'Customize',
                'translate': 'NAV.CUSTOM_SETTINGS.TITLE',
                'type'    : 'item',
                'icon'    : 'settings',
                'function': () => {
                    this.openBar();
                }
            }
        
        );

    }

    ngOnInit()
    {
        this.renderer.listen(this.overlay.nativeElement, 'click', () => {
            this.closeBar();
        });
    }

    ngOnDestroy()
    {
        const idx = navigation.findIndex(item => item.id === 'custom-function');
        const subIdx = navigation[idx].children.findIndex(item => item.id === 'customize');
        navigation[idx].children.splice(subIdx, 1);
        this.onConfigChanged.unsubscribe();
    }

    onSettingsChange()
    {
        this.fuseConfig.setConfig(this.config, true);
    }

    closeBar()
    {
        this.player =
            this.animationBuilder
                .build([
                    style({transform: 'translate3d(0,0,0)'}),
                    animate('400ms ease', style({transform: 'translate3d(100%,0,0)'}))
                ]).create(this.panel.nativeElement);

        this.player.play();

        this.player.onDone(() => {
            this.barClosed = true;
        });
    }

    openBar()
    {
        this.barClosed = false;
        this.player =
            this.animationBuilder
                .build([
                    style({transform: 'translate3d(100%,0,0)'}),
                    animate('400ms ease', style({transform: 'translate3d(0,0,0)'}))
                ]).create(this.panel.nativeElement);

        this.player.play();
    }
}





// WEBPACK FOOTER //
// ./src/@fuse/components/theme-options/theme-options.component.ts